module.exports = __webpack_public_path__ + "media/images/australia-7333f60a7ec452ca6e2188f17b3b7457.png";